const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

/**
 * @param {Context} context
 * @param {Customer} currentUser
 * @param {Maybe<CustomQuery>} customQuery
 */
const addBillingAddress = async (context, currentUser, address) => {
  const addressKey = `${address.postalCode}-${Date.now()}`;
  const addressWithKey = {
    ...address,
    key: addressKey,
  };

  // Step 1: Add address to customer
  const actions = [
    {
      addAddress: {
        address: addressWithKey,
      },
    },
    {
      addBillingAddressId: {
        addressKey,
      },
    },
  ];

  const options = {
    mutation: customerUpdateMeQuery,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };

  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = addBillingAddress;
